import "./Tourn.css"; // Import the CSS file

function MyTournaments() {
    return (
        <div className="createdTournContainer">
            {/*HTML CODE GOES IN HERE :> -KD  */}
            <h2 className="p_TournTitle">Created Tournaments</h2>
            <div className="p_TournAlign">
                <div className="createdTourn_Name">
                    <ul className="myTourn_ListA">
                    <p className="p_TournData1"> myData_Name </p>
                    <p className="p_TournData2"> myData_Name </p>
                    <p className="p_TournData1"> myData_Name </p>
                    <p className="p_TournData2"> myData_Name </p>
                    <p className="p_TournData1"> myData_Name </p>
                    </ul>
                    </div>
                    
            </div>

        </div>
    );
}

export default MyTournaments;
